import _, { get } from "lodash";
import store from "@/store";
import ClientRepository from "@/repositories/socle/ClientRepository";

export interface SocleClient {
  uuid: string;
  moduleName: string;
  mainKpi: string;
  flatFeesAmount: number;
  flatFeesDescription: string;
  approvalDaysBeforeDeadline: number;
  lightMode: boolean;
  lightLeverMode: boolean;
  textNote: string | null;
  textNoteSub: string | null;
  levers: SocleClientLever[];
  ownerUuid: string;
  approvalRequired: boolean;
}

export interface SocleClientLever {
  budgetModificationRule: string;
  lever: {
    code: string;
    uuid: string;
  };
}

export default {
  state: {
    client: null,
  },
  mutations: {
    setSocleClient: (state: any, client: SocleClient) => {
      _.set(state, "client", client);
    },
  },
  getters: {
    getSocleClient: (state: { client: SocleClient }): SocleClient => {
      return state.client;
    },
    getSocleModuleName: (state: { client: SocleClient }): string => {
      return state.client?.moduleName ? state.client.moduleName : "Socle";
    }
  },
  actions: {
    loadSocleClient: ({ commit, dispatch, state }: any): Promise<void> => {
      return new Promise((resolve, reject) => {
        const paramsGetOwnerData = {
          fields: [
            "moduleName",
            "approvalDaysBeforeDeadline",
            "uuid",
            "mainKpi",
            "lightMode",
            "lightLeverMode",
            "textNote",
            "textNoteSub",
            "flatFeesAmount",
            "flatFeesDescription",
            "levers.budgetModificationRule",
            "levers.lever.code",
            "levers.lever.uuid",
            "levers.rank",
            "approvalRequired",
          ],
          filters: {
            ownerUuid: _.get(store, "getters.getCurrentOwnerUuid", ""),
          }
        };

        ClientRepository.get(paramsGetOwnerData)
        .then((data: object[]) => {
          commit("setSocleClient", data[0]);
          resolve();
        })
        .catch(() => {
          commit("setSocleClient", null);
          reject();
        });
      });
    }
  },
};
